module.exports = __webpack_public_path__ + "static/img/about.87762e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about.png
// module id = FaTB
// module chunks = 1